import ApiClient from '@afosto/api/ApiClient';

class Methods {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Get method
   *
   * @param {string} id
   * @param {Object} query - The optional path parameters
   * @param {string} [query.channelId]
   * @param {string} [query.countryCode]
   * @param {Object} options - The additional request options
   * @description List all methods
   * @returns {Promise}
   */
  getShippingMethod(id, query = {}, options = {}) {
    const params = {
      channel_id: query.channelId,
      country_code: query.countryCode,
    };

    return this.apiClient.request({
      url: `/lcs/methods/${id}`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * List methods
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.channelId]
   * @param {string} [query.countryCode]
   * @param {Object} options - The additional request options
   * @description List all methods
   * @returns {Promise}
   */
  listMethods(query = {}, options = {}) {
    const params = {
      channel_id: query.channelId,
      country_code: query.countryCode,
    };

    return this.apiClient.request({
      url: `/lcs/methods`,
      method: 'get',
      params,
      ...options,
    });
  }
}

export const methods = new Methods();

export default Methods;
